(function () {
  'use strict';

  angular
    .module('service.authentication', [])

    /* @ngInject */
    .factory('LogService', ["$templateCache", "AccountService", "HttpService", "Routes", "DefaultLocalization", function ($templateCache, AccountService, HttpService, Routes, DefaultLocalization) {
      var redirect,
        redirect2,
        email;

      return {
        login: function (data) {
          return HttpService.post({
            url: '/' + Routes.filter(function (r) { return r.Name === 'Login'; })[0][DefaultLocalization].URL,
            data: data
          })
          .then(function (response) {
            window.dataLayer = window.dataLayer || [];
            dataLayer.push({
              'event': 'userLogged',
              'userMail': data.Login
            });

            return response;
          })
          .catch(function (error) {
            console.error(error);
          });
        },
        logout: function () {
          return HttpService.post({
            url: '/Logout',
            data: {}
          })
          .then(function (response) {
            $templateCache.remove(AccountService.getLinks().AccountUpdate);
            $templateCache.remove(AccountService.getLinks().AccountHome);
            return response;
          })
          .catch(function (error) {
            console.error(error);
          });
        },
        redirect: redirect,
        redirect2: redirect2,
        email: email
      };
    }]);

})();
